import type { TournamentsApi } from '@/v2/api/metadata/tournaments'
import type { BackofficeContext } from '@/v2/framework/context/types'
import type { TranslationsTab } from '@/v2/framework/dialog/types'
import { readApiData } from '@/v2/api/response'
import { formatTranslationsForUpdate } from '@/services/helpers'
import { buildTournamentTranslationFields } from '../../translation-fields'

export function createTranslationsTab(options: {
  ctx: BackofficeContext
  tournamentsApi: TournamentsApi
}): TranslationsTab {
  const { ctx, tournamentsApi } = options

  return {
    kind: 'translations',
    id: 'translations',
    label: 'Translations',
    persistence: 'isolated',
    parentSubmitWithUnsavedTranslations: 'block',
    fields: buildTournamentTranslationFields,
    api: {
      get: async ({ values }) => {
        const tournament = values as { id: string | number }
        const translations = readApiData(await tournamentsApi.getTranslations(tournament.id))
        const list = Array.isArray(translations) ? translations : []

        const languages = ctx.read.languages()
        const translationsPerLanguage = (list as Array<{ languageId: string | number }>).reduce(
          (acc, translation) => {
            acc.set(String(translation.languageId), translation)
            return acc
          },
          new Map(),
        )

        return {
          languages,
          translationsPerLanguage,
        }
      },
      save: async (model, saveCtx) => {
        const entityId = (saveCtx.values as { id: string | number }).id
        await tournamentsApi.update(entityId, {
          translations: formatTranslationsForUpdate(
            model as Parameters<typeof formatTranslationsForUpdate>[0],
          ),
        })
      },
    },
  }
}
